import * as ko from "knockout";
import { Spinner } from "spin.js";

class SpinnerState {
  public static loaderInstances = ko.observable(0);
}

class GlobalSpinner {
  private static target: HTMLElement;
  private static _spinnerContainer: HTMLElement;
  private static spinner = new Spinner({
    className: "spinnerx",
  });

  public spin(fullOpacity: boolean = true): void {
    SpinnerState.loaderInstances(SpinnerState.loaderInstances() + 1);

    if (SpinnerState.loaderInstances() > 1) {
      return;
    }

    if (!GlobalSpinner.target) {
      GlobalSpinner.target = document.getElementById("page");
    }

    const pageElement = document.getElementById("page");
    const element = GlobalSpinner.target || pageElement;

    const pageHeight = pageElement && pageElement.clientHeight > 0 ? `;height: ${pageElement.clientHeight}px` : "";

    const wrapperContainer = document.createElement("div");
    let resultTarget = document.createElement("div");
    resultTarget.classList.add("ProgressBG");
    resultTarget.style.zIndex = `99999`;
    resultTarget.style.position = `absolute`;
    resultTarget.style.top = `0`;
    resultTarget.style.left = `0`;
    resultTarget.style.right = `0`;
    resultTarget.style.bottom = `0`;
    resultTarget.style.height = `${pageHeight}`;
    resultTarget.style.backgroundColor = `rgba(247, 251, 255, ${fullOpacity ? "1" : "0.8"})`;

    GlobalSpinner._spinnerContainer = resultTarget;
    wrapperContainer.appendChild(resultTarget);

    while (wrapperContainer.children.length > 0) {
      element.appendChild(wrapperContainer.children[0]);
    }
    GlobalSpinner._spinnerContainer = resultTarget;
    GlobalSpinner.spinner.spin(element);
  }

  public stop(): void {
    SpinnerState.loaderInstances(SpinnerState.loaderInstances() - 1);
    if (SpinnerState.loaderInstances() > 0) {
      return;
    }

    try {
      GlobalSpinner.target.removeChild(GlobalSpinner._spinnerContainer);
    } catch {}

    GlobalSpinner.spinner.stop();
  }
}

export const systemSpinner = new GlobalSpinner();
